export namespace AssetTransactionTranslations {
  export const common = {
    assetTransaction: 'assetTransaction',

    completedReturn: 'completedReturn',
    completedAssign: 'completedAssign',
    pendingReturn: 'pendingReturn',
    pendingAssign: 'pendingAssign',
    returnToUser: 'returnToUser',
    ownershipConfirmed: 'ownershipConfirmed',
    pendingOwnershipConfirmation: 'pendingOwnershipConfirmation',
  } as const;

  export const error = {
    assetTransactionsUnableToLoadError: 'assetTransactionsUnableToLoadError',

    assetTransactionVerifyOwnershipMissingLocationError: 'assetTransactionVerifyOwnershipMissingLocationError',
    assetTransactionVerifyOwnershipExistingRequestError: 'assetTransactionVerifyOwnershipExistingRequestError',
    assetTransactionConfirmOwnershipInvalidStatusError: 'assetTransactionConfirmOwnershipInvalidStatusError',
  } as const;

  export const components = {
    assetTransactionVerifyOwnershipButton: 'assetTransactionVerifyOwnershipButton',

    assetTransactionSignVerifyLabel: 'assetTransactionSignVerifyLabel',
    assetTransactionSignVerifyModalTitle: 'assetTransactionSignVerifyModalTitle',
  } as const;
}
